import { Component, HostBinding, isDevMode, enableProdMode, ViewChild } from '@angular/core';
import { OverlayContainer } from '@angular/cdk/overlay';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse, HttpParams } from '@angular/common/http';
import { SwUpdate } from '@angular/service-worker';

import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
//https://stackblitz.com/edit/angular-material-theme-secrets?embed=1&file=src%2Ftheme.scss&source=post_page---------------------------
//https://www.techiediaries.com/angular-material-navigation-toolbar-sidenav/

import { CommonFilterService } from './shared/services/common-filter/common-filter.service';
import { LoginComponent } from './login/login.component';
import { SystemSettingsService } from './shared/services/system-settings/system-settings.service';
import { VersionCheckService } from './shared/services/version-check/version-check.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title: string;
  staticScreen = true;
  refreshClicked = false;

  isLogin: boolean = true;
  isVQT: boolean = false;
  isPolqa: boolean = false;
  isVBA: boolean = false;
  isNetTest: boolean = false;
  isVac: boolean = false;
  isEmu: boolean = false;
  isFax: boolean = false;
  isAudioandDelay: boolean = false;
  isCallEvents: boolean = false;
  isCallEventsStats: boolean = false;
  isAudioandDelayStats: boolean = false;
  isVoiceQualityStats: boolean = false;
  isSchedulerStatus: boolean = false;
  isNetworkStatus: boolean = false;
  isFilters: boolean = false;
  statusScreens: boolean = false;
  isGraphics: boolean = false;
  isCallProcessGraphics: boolean = false;
  isAnalysisGraphics: boolean = false;
  isNetTestGraphics: boolean = false;
  isOutputResults: boolean = false;
  isCustomReports: boolean = false;
  isGoogleMaps: boolean = false;
  isConsoleView: boolean = false;
  isConfiguration: boolean = false;
  isRemoteOperations: boolean = false;
  isWebviewerConfig: boolean = false;
  showHelp: boolean = false;

  currentTheme = '';
  @HostBinding('class') componentCssClass;

  //@ViewChild(LoginComponent, { static: true }) loginChild: LoginComponent;
  baseUrl: string;
  url: string;

  routerGrp = "Results";
  routerGrpItem = "PESQ";

  constructor(private http: HttpClient, public overlayContainer: OverlayContainer, public _router: Router, public _location: Location,
    private commonFilterService: CommonFilterService, private versionCheckService: VersionCheckService, private swUpdate: SwUpdate, private logservice: SystemSettingsService, private routeActive: ActivatedRoute) {

    //this.versionCheckService.initVersionCheck();
    if (swUpdate.isEnabled) {
      swUpdate.available.subscribe(() => {
        console.log('New version available. Reloading...');
        swUpdate.activateUpdate().then(() => document.location.reload());
      });
    }

    ///// this.checkInternetConnection();
    //alert('appcomp');
    this.onSetTheme('defaultMat');

    this.baseUrl = environment.urlAddress + '/api/';
    //this.logservice.appPageRef.subscribe(res => { console.log(res + '0'); this.RestrictScreenAfterLogin(res); });

    console.log(environment.urlAddress);
    console.log(environment.production);


    if (isDevMode()) {
      console.log('👋 Development!');
    } else {
      //https://www.grapecity.com/blogs/14-ways-to-speed-up-your-angular-app
      enableProdMode();
      console.log('💪 Production!');
    }
    //https://stackoverflow.com/a/68525726
    //https://stackoverflow.com/questions/53230823/fatal-error-ineffective-mark-compacts-near-heap-limit-allocation-failed-javas
    //SET NODE_OPTIONS=--max_old_space_size=8192
    //https://stackoverflow.com/questions/62288814/cache-busting-is-not-working-sometimes-after-production-build-in-angular-7
    //ng build --prod --aot --output-hashing=all

    //npm install leaflet @types/leaflet @types/geojson@7946.0.8 @types/leaflet.markercluster  overlapping-marker-spiderfier-leaflet leaflet.markercluster leaflet-polylinedecorator leaflet-routing-machine @asymmetrik/ngx-leaflet@6.0.1
    //npm install @angular/pwa @angular/service-worker@8.2.2
    //npm install jspdf --save
    //npm install dom-to-image --save

    //"ts-overlapping-marker-spiderfier": "^1.0.2",
    //"agm-oms": "^1.0.0-beta.5",

    //Install-Package Ubiety.Dns.Core -Version 2.2.1 - Webviewer_API projs

    //https://medium.com/@Codeible/adding-loading-and-using-javascript-in-angular-3281ea4b056b
    //https://stackoverflow.com/questions/41376263/angular-2-referencing-external-js-file-in-index-html

    //https://stackoverflow.com/questions/50113794/angular-how-to-dynamically-change-the-content-in-the-index-html-file-when-runn
    //https://www.freecodecamp.org/news/private-api-keys/
    //https://www.dhiwise.com/post/how-to-hide-javascript-source-code
    //https://stackoverflow.com/questions/64365318/how-can-i-set-my-google-maps-key-in-index-html-dynamically-in-angular-2
  }
  //https://www.youtube.com/watch?v=m5OzOczDmhU
  //https://stackoverflow.com/questions/47813927/how-to-refresh-a-component-in-angular
  //https://www.newline.co/@kievsash/mastering-angular-8:-five-things-that-are-good-to-know-to-save-your-time.--6302e8aa
  //refresh(): void {
  //  this._router.navigateByUrl("refresh", { skipLocationChange: true }).then(() => {
  //    console.log(decodeURI(this._location.path()));
  //    this._router.navigate([decodeURI(this._location.path())]);
  //  });
  //}

  routeClick(type, subType?) {
    this.routerGrp = type;
    this.routerGrpItem = subType;
  }

  onSetTheme(theme) {
    this.currentTheme = theme;
    this.overlayContainer.getContainerElement().classList.add(theme);
    this.componentCssClass = theme;
  }

  //https://medium.com/@sujeeshdl/angular-parent-to-child-and-child-to-parent-communication-from-router-outlet-868b39d1ca89
  //currComponentReference: any;
  onActivate(componentReference) {
    //alert('activate');

    this.isLogin = true;
    this.isVQT = false;
    this.isPolqa = false;
    this.isVBA = false;
    this.isNetTest = false;
    this.isVac = false;
    this.isEmu = false;
    this.isFax = false;
    this.isAudioandDelay = false;
    this.isCallEvents = false;
    this.isCallEventsStats = false;
    this.isAudioandDelayStats = false;
    this.isVoiceQualityStats = false;
    this.isSchedulerStatus = false;
    this.isNetworkStatus = false;
    this.isFilters = false;
    this.statusScreens = false;
    this.isGraphics = false;
    this.isCallProcessGraphics = false;
    this.isAnalysisGraphics = false;
    this.isNetTestGraphics = false;
    this.isOutputResults = false;
    this.isCustomReports = false;
    this.isGoogleMaps = false;
    this.isConsoleView = false;
    this.isConfiguration = false;
    this.isRemoteOperations = false;
    this.isWebviewerConfig = false;
    //debugger;
    ////to check if request is to reset password from email link clicked
    const forgotPasswordKey = this.routeActive.snapshot.queryParamMap.get('fkey');
    //console.log(forgotKey);


    //// to check if user is loggedin or not
    //console.log(this.logservice.UserName)
    if (this.logservice.UserName == "" && this._router.url != "/forgotpassword") {
      //debugger
      //console.log(sessionStorage.getItem('SystemSettings') == null)
      //console.log(localStorage.getItem('SystemSettings'))
      //console.log(sessionStorage.getItem('Keyword') == null)
      //console.log(localStorage.getItem('Keyword'))
      //console.log(localStorage.getItem('ConfigScreen') == null)
      //console.log('keysetchk')
      //console.log(localStorage.getItem('Keyword'))
      if (sessionStorage.getItem('SystemSettings') == null && localStorage.getItem('SystemSettings') == null
        && sessionStorage.getItem('Keyword') == null && localStorage.getItem('Keyword') == null && forgotPasswordKey == null) {
        //console.log('redirect to login app')
        if (localStorage.getItem('ConfigScreen') == null)
          this._router.navigateByUrl('/login');
        
      }
      else {
        //https://www.sohamkamani.com/javascript/localstorage-with-ttl-expiry/
        //https://long2know.com/2017/12/angular-user-session-timeout/
        //https://www.c-sharpcorner.com/article/how-to-set-and-get-cookies-in-angular-with-example/
        //if (sessionStorage.getItem('Keyword') != null || localStorage.getItem('Keyword') != null)
        //  this.LicenceCheck();

        let logserviceObj;
        if (sessionStorage.getItem('SystemSettings') != null) {
          logserviceObj = JSON.parse(sessionStorage.getItem('SystemSettings'));
        }
        else if (localStorage.getItem('SystemSettings') != null) {
          logserviceObj = JSON.parse(localStorage.getItem('SystemSettings'));
        }

        if (logserviceObj) {
          this.logservice.logDetail = logserviceObj.logDetail;
          this.logservice.LogType = logserviceObj.LogType;
          this.logservice.CompanyLogo = logserviceObj.CompanyLogo;
          this.logservice.CompanyRebrand = logserviceObj.CompanyRebrand;
          this.logservice.UserName = logserviceObj.UserName;
          this.logservice.isLoggedIn = logserviceObj.isLoggedIn;
          this.logservice.isCommonLogo = logserviceObj.isCommonLogo;
          this.logservice.startupScreen = logserviceObj.startupScreen;
          this.logservice.restrictScreens = logserviceObj.restrictScreens;
          //console.log(this.logservice)
          if (this.logservice.restrictScreens)
            this.RestrictScreenAfterLogin(this.logservice.restrictScreens);
        }

        //if (sessionStorage.getItem('Keyword') != null) {
        //  let Keyword = sessionStorage.getItem('Keyword');
        //  this._router.navigateByUrl('/login?k=' + Keyword);
        //}
        //else if (localStorage.getItem('Keyword') != null) {
        //  let Keyword = localStorage.getItem('Keyword');
        //  this._router.navigateByUrl('/login?k=' + Keyword);
        //}
      }
    }
    else {
      //console.log(this.logservice)
      if (this.logservice.restrictScreens)
        this.RestrictScreenAfterLogin(this.logservice.restrictScreens);

      //if (this.logservice.startupScreen.split('|')[2] != "undefined" && this.logservice.startupScreen.split('|')[2] != "") {
      //  this.isFilters = true;
      //}
      //else
      //  this.isFilters = false;
    }

    this.commonFilterService.setIsFilters(this.isFilters);

    //https://stackoverflow.com/questions/48400422/angular4-router-outlet-activate-and-expressionchangedafterithasbeencheckederror
    //https://medium.com/better-programming/expressionchangedafterithasbeencheckederror-in-angular-what-why-and-how-to-fix-it-c6bdc0b22787
    setTimeout(() => {
      if (componentReference) {
        this.title = componentReference.title;
        this.staticScreen = componentReference.staticScreen;


        //this.currComponentReference = componentReference;//set to call in refresh/auto-refresh functions down - IMP
        //if (this.refreshClicked)
        //  componentReference.refreshClicked();   //Below will subscribe to the child - check call event comp.ts

        componentReference.childTitleEvent.subscribe((data) => {
          // Will receive the data from child here
          this.title = data.title;
          this.staticScreen = data.staticScreen;
        })
        this.refreshClicked = !this.refreshClicked;
      }
    });

    //console.log(this._router.url)
    if (this._router.url.indexOf('/dashboard') != -1) {
      this.routerGrp = "Results";
      if (this._router.url.indexOf('/call-events') != -1)
        this.routerGrp = "CallEvents";
      else {
        if (this._router.url.indexOf('/pesq') != -1)
          this.routerGrpItem = "PESQ";
        else if (this._router.url.indexOf('/polqa') != -1)
          this.routerGrpItem = "POLQA";
        else if (this._router.url.indexOf('/audio-delay') != -1)
          this.routerGrpItem = "TDM";
        else if (this._router.url.indexOf('/nettest') != -1)
          this.routerGrpItem = "NetTest";
        else if (this._router.url.indexOf('/vac') != -1)
          this.routerGrpItem = "VAC";
        else if (this._router.url.indexOf('/emu') != -1)
          this.routerGrpItem = "EMU";
        else if (this._router.url.indexOf('/fax') != -1)
          this.routerGrpItem = "FAX";
        else if (this._router.url.indexOf('/vba') != -1)
          this.routerGrpItem = "VBA";
      }
    }
    else if (this._router.url.indexOf('/statistics') != -1) {
      this.routerGrp = "Statistics";
      if (this._router.url.indexOf('/AudioDelayStatsPieChart') != -1)
        this.routerGrpItem = "TDM";
      else if (this._router.url.indexOf('/VoiceQualityStatsPieChart') != -1)
        this.routerGrpItem = "VQT";
      else if (this._router.url.indexOf('/scheduler') != -1)
        this.routerGrpItem = "Scheduler";
      else if (this._router.url.indexOf('/nsvquad') != -1)
        this.routerGrpItem = "NwStatus";
    }
    else if (this._router.url.indexOf('/graphics') != -1 || this._router.url.indexOf('/outputresult') != -1) {
      this.routerGrp = "Reports";

      if (this._router.url.indexOf('/call-process') != -1)
        this.routerGrpItem = "CallProc";
      else if (this._router.url.indexOf('/analysis') != -1)
        this.routerGrpItem = "Analysis";
      else if (this._router.url.indexOf('/nettest-graphs') != -1)
        this.routerGrpItem = "NetTest";
      else if (this._router.url.indexOf('/CustomReport') != -1)
        this.routerGrpItem = "CustomReports";
      else if (this._router.url.indexOf('/GoogleMap') != -1)
        this.routerGrpItem = "GoogleMaps";
      else if (this._router.url.indexOf('/AdvGoogleMap') != -1)
        this.routerGrpItem = "AdvGoogleMaps";
      else if (this._router.url.indexOf('/ConsoleView') != -1)
        this.routerGrpItem = "ConsoleView";
    }
  }

  screenTopRef() {
    //this.refreshClicked = true;
    //this.onActivate(this.currComponentReference);

    //https://stackoverflow.com/questions/40788458/how-to-call-component-method-from-service-angular2
    //https://stack247.wordpress.com/2018/05/22/angular-call-child-components-method-in-parent-components-template/
    //ViewChild
    this.commonFilterService.basicRefresh();
  }

  screenTopAutoRef(AutoRefreshInfo) {
    this.commonFilterService.basicAutoRefresh(AutoRefreshInfo);
  }

  RestrictScreenAfterLogin(screenList) {
    //alert(this.logservice.LogType);
    //console.log(screenList + '0');
    //debugger;
    for (let i = 0; i < screenList.split(';').length; i++) {

      switch (screenList.split(';')[i]) {
        case "VQT":
          //if (rsltAll == 0) {
          //  vp.Enabled = false;
          //  vp.Visible = false;
          //  PESQDummy.Visible = true;
          //}
          this.isVQT = true;
          break;
        case "VPOL":
          //if (rsltAll == 0) {
          //  vpol.Enabled = false;
          //  vpol.Visible = false;
          //  POLQADummy.Visible = true;
          //}
          this.isPolqa = true;
          break;
        case "VBA":
          //if (rsltAll == 0) {
          //  vba.Enabled = false;
          //  vba.Visible = false;
          //  VBADummy.Visible = true;
          //}
          this.isVBA = true;
          break;
        case "TDM":
          //if (rsltAll == 0) {
          //  tdm.Enabled = false;
          //  tdm.Visible = false;
          //  TDMDummy.Visible = true;
          //}
          this.isAudioandDelay = true;
          break;
        case "CE":
          //if (rsltAll == 0) {
          //  ud.Enabled = false;
          //  ud.Visible = false;
          //  CEDummy.Visible = true;
          //}

          break;
        case "ER":
          //if (rsltAll == 0) {
          //  emu.Enabled = false;
          //  emu.Visible = false;
          //  EMUDummy.Visible = true;
          //}
          this.isEmu = true;
          break;
        case "VR":
          //if (rsltAll == 0) {
          //  vac.Enabled = false;
          //  vac.Visible = false;
          //  VACDummy.Visible = true;
          //}
          this.isVac = true;
          break;
        case "CVS":
          //if (rsltAll == 0) {
          //  btnConsoleView.Enabled = false;
          //  btnConsoleView.Visible = false;
          //  CVSDummy.Visible = true;
          //}
          this.isConsoleView = true;
          break;
        case "NR":
          //if (rsltAll == 0) {
          //  tcp.Enabled = false;
          //  tcp.Visible = false;
          //  TCPDummy.Visible = true;
          //}
          this.isNetTest = true;
          break;
        case "FR":
          //if (rsltAll == 0) {
          //  fax.Enabled = false;
          //  fax.Visible = false;
          //  FAXDummy.Visible = true;
          //}
          this.isFax = true;
          break;
        case "VQUAD":
          //cc.Enabled = false;
          this.isCallEvents = true;
          break;
        case "AR":
          //pnlAutoRefresh.Enabled = false; ///TBD
          break;
        case "CS":
          //STATS_COMPLETEDCALL.Enabled = false;
          //STATS_COMPLETEDCALL.Visible = false;
          //CSDummy.Visible = true;
          break;
        case "NS":
          //STATS_NETWORKSTATUS.Enabled = false;
          //STATS_NETWORKSTATUS.Visible = false;
          //NSDummy.Visible = true;
          this.isNetworkStatus = true;
          this.statusScreens = true;
          break;
        case "SCH":
          //STATS_SCHEDULERSTATUS.Enabled = false;
          //STATS_SCHEDULERSTATUS.Visible = false;
          //SCHDummy.Visible = true;
          this.isSchedulerStatus = true;
          this.statusScreens = true;
          break;
        case "SC":
          //sc.Attributes.Clear();
          //sc.Attributes.Add("style", "cursor:text;");
          //sc.Enabled = false;
          //filterEnable = 1;
          this.isFilters = true;
          break;
        case "OR":
          //liOutput.Disabled = true;
          //liOutput.Attributes.Add("onClick", "InvisibleSub('Output');");
          //aOutput.Disabled = true;
          //aOutput.Attributes.Add("onMouseOver", "InvisibleSub('Output');");
          //outputEnable = 1;
          this.isOutputResults = true;
          break;
        case "GD_CALL":
          //if (gdAll == 0) {
          //  gd_Call.Enabled = false;
          //  gd_Call.Visible = false;
          //  CallDummy.Visible = true;
          //}
          this.isCallProcessGraphics = true;
          break;
        case "GD_ANALYSIS":
          //if (gdAll == 0) {
          //  gd_Analysis.Enabled = false;
          //  gd_Analysis.Visible = false;
          //  AnalysisDummy.Visible = true;
          //}
          this.isAnalysisGraphics = true;
          break;
        case "GD_NETTEST":
          //if (gdAll == 0) {
          //  gd_NetTest.Enabled = false;
          //  gd_NetTest.Visible = false;
          //  NetTestDummy.Visible = true;
          //}
          this.isNetTestGraphics = true;
          break;
        case "RC"://remote operation
          //if (rmtAll == 0) {
          //  VQuad.Enabled = false;
          //  VQuad.Visible = false;
          //  RODummy.Visible = true;
          //}
          this.isRemoteOperations = true;
          break;
        case "VAR"://vquad auto remote
          //if (rmtAll == 0) {
          //  AutoRemote.Enabled = false;
          //  AutoRemote.Visible = false;
          //  VARDummy.Visible = true;
          //}

          break;
        default:
          return;
      }

    }
  }


  ///to check software licence
  LicenceCheck() {

    this.logservice.UserName = "";//IMP IMP
    //this.url = this.baseUrl + 'ITS/ITSRTSCheck';
    //this.GetLicData_Service().subscribe((res: any) => {

    //});
    this.url = this.baseUrl + 'Login/LicenseCheck';

    this.GetLicData_Service().subscribe((res: any) => {
      //debugger;
      let rows: any = res;//JSON.parse(res) as any;
      //console.log(rows + 'appLic')
      if (rows == "failed") {
        this.logservice.UserName = "LicenseCheck";
        this._router.navigateByUrl('login/LicenseCheck');
      }
      else {
        /// get LoginType
        this.url = this.baseUrl + 'Login/GetLoginType';

        this.GetData_Service().toPromise().then((res: any) => {
          //debugger;
          let rows: any = res;//JSON.parse(res) as any;
          //console.log('appTyped');
          if (rows != "" && rows != "Login failed") {
            this.logservice.LogType = rows;
            this.logservice.CompanyLogo = './assets/images/' + this.logservice.LogType + '/' + this.logservice.LogType + '_logo.png';
            this.logservice.CompanyRebrand = './assets/images/Rebrand/Rebrand.png';
          }

        });
    //console.log('loginTypedDone');
      }
    });
    //console.log('licensedDone');
  }

  GetLicData_Service() {

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };

    return this.http.post<any>(this.url, options);

  }

  GetData_Service() {

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };

    return this.http.post<any>(this.url, options);

  }

  checkInternetConnection = async () => {
    try {
      const response = await fetch('https://chart.googleapis.com/chart?chst=d_map_xpin_letter&chld=pin|E|000000|FFFFFF');
      this.showHelp = false;
      if (response.ok) {
        console.log("Internet connection is available.");
      } else {
        console.log("Internet connection is not available.");
        this.showHelp = true;
      }
    } catch (error) {
      console.log("Internet connection is not available.");
      this.showHelp = true;
    }
  };

}
